import auth from './auth'
import locale from './locale'
import users from './users'
import sections from './sections'
import documents from './documents'
import countries from './countries'
import business from './business'
import catalogs from './catalogs'
import admins from './admins'
import profiles from './profiles'
import emails from './emails'
import blacklist from './blacklist'
import evaluators from './evaluators'
import rolesProcess from './rolesProcess'
import supplier from './supplier'
import bitacora from './bitacora'
import typeUsers from './typeUsers'
import certificado from './certificado'
import digitalForm from './digitalForm'

export default {
  ...auth,
  ...locale,
  ...users,
  ...sections,
  ...countries,
  ...business,
  ...documents,
  ...catalogs,
  ...admins,
  ...profiles,
  ...emails,
  ...blacklist,
  ...evaluators,
  ...rolesProcess,
  ...supplier,
  ...bitacora,
  ...typeUsers,
  ...certificado,
  ...digitalForm
}